import JobHighlightPills from "./JobHighlightPills";

const COMPANY_MARK_PALETTE = [
  "nd1-applicant-job-card__mark--green",
  "nd1-applicant-job-card__mark--dark",
  "nd1-applicant-job-card__mark--purple",
  "nd1-applicant-job-card__mark--blue",
];

function companyInitials(name) {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
}

function companyMarkClass(name) {
  const label = String(name || "").trim();
  if (!label) return COMPANY_MARK_PALETTE[0];
  let hash = 0;
  for (let i = 0; i < label.length; i += 1) {
    hash = (hash + label.charCodeAt(i) * (i + 1)) % COMPANY_MARK_PALETTE.length;
  }
  return COMPANY_MARK_PALETTE[hash];
}

export default function ApplicantJobSearchResultCard({
  job,
  index,
  statusRow = null,
  onOpen,
}) {
  if (!job) return null;

  const company = String(job.company || "").trim();
  const logoUrl = String(job.companyLogoUrl || "").trim();
  const markClass = companyMarkClass(company);
  const summary = String(job.summary || "").trim();

  return (
    <article
      data-job-search-result-id={String(job.id)}
      className="nd1-applicant-job-search-result-card"
      role="link"
      tabIndex={0}
      onClick={onOpen}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onOpen();
        }
      }}
    >
      <span className="nd1-applicant-job-search-result-card__index" aria-label={`Result ${index + 1}`}>
        {index + 1}
      </span>

      <div className="nd1-applicant-job-search-result-card__body">
        <div className="nd1-applicant-job-search-result-card__head">
          <div className="nd1-applicant-job-search-result-card__head-main">
            <h3 className="nd1-applicant-job-search-result-card__title">{job.title || "Role"}</h3>
            {company ? (
              <p className="nd1-applicant-job-search-result-card__company">{company}</p>
            ) : null}
          </div>
          <div className={`nd1-applicant-job-search-result-card__logo ${markClass}`}>
            {logoUrl ? (
              <img src={logoUrl} alt="" loading="lazy" />
            ) : (
              <span aria-hidden="true">{companyInitials(company)}</span>
            )}
          </div>
        </div>

        {statusRow}

        <JobHighlightPills job={job} variant="job-search" />

        {summary ? <p className="nd1-applicant-job-search-result-card__summary">{summary}</p> : null}
      </div>
    </article>
  );
}
